<div class="date-time-picker" [ngClass]="{'readonly': readonly}">
  <kendo-datepicker *ngIf="format" [format]="format" [ngClass]="{'dayOnly': dayOnly}" [min]="min" [max]="max"
    [(value)]="date" [disabled]="disabled" [readonly]="readonly || dateReadonly" [class.readonly]="readonly || dateReadonly"
    (valueChange)="dateOnChange($event)" (blur)="handleOnTouched()" (input)="handleOnTouched()"></kendo-datepicker>
  <kendo-datepicker *ngIf="!format" [ngClass]="{'dayOnly': dayOnly}" [min]="min" [max]="max" [(value)]="date"
    [disabled]="disabled" [readonly]="readonly || dateReadonly" [class.readonly]="readonly || dateReadonly" (valueChange)="dateOnChange($event)"
    (blur)="handleOnTouched()" (input)="handleOnTouched()"></kendo-datepicker>
  <kendo-timepicker *ngIf="!dayOnly" [steps]="steps" [min]="timePickerMin" [max]="max" [(value)]="time" [disabled]="disabled"
    [readonly]="readonly" [class.readonly]="readonly" (valueChange)="timeOnChange($event)" (blur)="handleOnTouched()"
    (input)="handleOnTouched()">
    <kendo-timepicker-messages cancelLabel="{{cancelToolTip | translate}}" acceptLabel="{{acceptToolTip | translate}}"
      cancel="{{cancelLabel | translate}}" accept="{{acceptLabel | translate}}">
    </kendo-timepicker-messages>
  </kendo-timepicker>

  <ng-template #clearButtonTemplate>
    <div class="d-flex justify-content-center align-items-center px-1">
      <qpoint-icon class="clear-date-btn" role="button" icon="xmark" (click)="clearValue()"></qpoint-icon>
    </div>
  </ng-template>
</div>